module.exports = __webpack_public_path__ + "img/quad-heating-sm.a735e41f.svg";